import React, { Component } from 'react'
import './styles.css'
import { apiEmployee } from '../../services/apiamrg'
import Header from '../../components/header'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import 'react-confirm-alert/src/react-confirm-alert.css'
import { Squares } from "react-activity";
import { Input } from '@material-ui/core'
const estadoInicial = {
    situacao: {},

    Chave: 0,
    Descricao: '',
    Codigo: '',

    textOptions: '',

    loading: false,
    redirect: false,
}

class AddOrdemSituacao extends Component {

    state = {
        ...estadoInicial,
    }

    componentDidMount = async () => {
        const { id } = this.props.match?.params;

        if (id != 0) {
            this.loadSituacao(id);
        }
    }

    loadSituacao = async (id) => {
        const situacao = await apiEmployee.get(`pegarsituacao/${id}`).then(res => res.data).catch((err) => ({}));

        this.setState({
            situacao,
            Chave: id,
            Descricao: situacao.Descricao,
            Codigo: situacao.Codigo
        })
    }

    saveSituacao = async () => {
        if (this.state.Chave != 0) {
            await apiEmployee.put(`atualizarsituacao/${this.state.Chave}`, {
                Descricao: this.state.Descricao,
                Codigo: this.state.Codigo
            }).then(res => {
                this.setState({ redirect: true })

            }).catch(err => console.log(err))
        } else if (this.state.Chave == 0) {
            await apiEmployee.post(`inserirsituacao`, {
                Descricao: this.state.Descricao,
                Codigo: this.state.Codigo
            }).then(res => {
                this.setState({ redirect: true })

            }).catch(err => console.log(err))
        }
    }

    render() {
        const validations = []
        validations.push(this.state.ship_name && this.state.ship_name.trim().length >= 3)


        //o formulário só será válido se todas as validações forem verdadeiras, com este reduce implementado
        const validForm = validations.reduce((t, a) => t && a)

        return (
            <div>
                {this.state.redirect &&
                    <Redirect to={'/admin/bens'} />
                }
                <Header voltarOrdemSituacao />

                <div className='titulo100'><span>Situação</span></div>

                <div className='centrom'>

                    <div className='col-9 row containeralterarcardapio'>
                        <div className='col-12 contcard contcard_only'>
                            <span>Código</span>
                            <Input disableUnderline={true} className="input-general" value={this.state.Codigo} onChange={(a) => this.setState({ Codigo: a.currentTarget.value })} />

                            <span>Nenhum valor</span>
                        </div>

                        <div className='col-12 contcard contcard_only'>
                            <span>Descrição</span>
                            <Input disableUnderline={true} className="input-general" value={this.state.Descricao} onChange={(a) => this.setState({ Descricao: a.currentTarget.value })} />

                            <span>Nenhum valor</span>
                        </div>

                        <div className='col-12 contvtt'>
                            <button type='button' onClick={() => this.saveSituacao()}>Salvar</button>

                            {this.state.loading && <Squares color={'black'} size={40} speed={0.5} />}
                        </div>

                    </div>

                </div>



            </div>
        )
    }
}

const mapStateToProps = ({ user, servidor }) => {
    return {
        token: user.token,
        online: servidor.online
    }
}

export default connect(mapStateToProps, null)(AddOrdemSituacao)